import ChangeSupport from './ChangeSupport';

export default {
  __init__: [ 'changeSupport' ],
  changeSupport: [ 'type', ChangeSupport ]
};